<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18 6.49359C18 6.07704 17.6823 5.73561 17.2766 5.69698L17.266 5.69328H12.3067V0.800242C12.3067 0.358064 11.9482 0.000123568 11.5066 0.000123568L0.800126 0C0.358114 0 0 0.358082 0 0.800118V11.5067C0 11.9484 0.357946 12.3068 0.800126 12.3068H5.69326V17.1999C5.69326 17.6415 6.0512 18 6.49338 18H17.1999C17.6416 18 18 17.6417 18 17.1999V6.49359ZM16.3997 7.29364V16.3996H7.29313V12.3069H11.5067C11.9484 12.3069 12.3068 11.9486 12.3068 11.5068L12.3069 7.29364H16.3997ZM1.59994 10.7067V1.6003H10.7063V5.69297L6.49274 5.69308C6.05073 5.69309 5.69262 6.05117 5.69262 6.4932V10.7067H1.59994Z"
    />
  </svg>
</template>
